import { render, staticRenderFns } from "./icon-docx.vue?vue&type=template&id=aaf9bdee&"
import script from "./icon-docx.vue?vue&type=script&lang=js&"
export * from "./icon-docx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports